import React from 'react';
import { IconBase, IconProps } from '../IconBase';

export const InsuranceAuthIcon = ({ size, color, title, onClick, decorative, ...restItems }: IconProps) => (
	<IconBase
		viewBox="0 0 24 24"
		size={size}
		color={color}
		title={title}
		onClick={onClick}
		decorative={decorative}
		{...restItems}
	>
		<path
			d="M5 5.5C4.71875 5.5 4.5 5.75 4.5 6V12.5H7.25C7.65625 12.5 8 12.8438 8 13.25C8 13.6875 7.65625 14 7.25 14H4.5V15.5H7.25C7.65625 15.5 8 15.8438 8 16.25C8 16.6875 7.65625 17 7.25 17H4.5V18C4.5 18.2812 4.71875 18.5 5 18.5H11C11 18.6562 11 18.7812 11 18.9062C11 19.3125 11.0938 19.6875 11.2812 20C11.1875 20 11.0938 20 11 20H5C3.875 20 3 19.125 3 18V6C3 4.90625 3.875 4 5 4H11C12.0938 4 13 4.90625 13 6V12.5V15.5C12.3438 15.8438 11.8438 16.375 11.5 17V6C11.5 5.75 11.25 5.5 11 5.5H5ZM7.25 7.5C7.25 7.25 7.46875 7 7.75 7H8.25C8.5 7 8.75 7.25 8.75 7.5V8.25H9.5C9.75 8.25 10 8.5 10 8.75V9.25C10 9.53125 9.75 9.75 9.5 9.75H8.75V10.5C8.75 10.7812 8.5 11 8.25 11H7.75C7.46875 11 7.25 10.7812 7.25 10.5V9.75H6.5C6.21875 9.75 6 9.53125 6 9.25V8.75C6 8.5 6.21875 8.25 6.5 8.25H7.25V7.5ZM19 12.5C19 13.4062 18.5 14.2188 17.75 14.6875C16.9688 15.125 16 15.125 15.25 14.6875C14.4688 14.2188 14 13.4062 14 12.5C14 11.625 14.4688 10.8125 15.25 10.3438C16 9.90625 16.9688 9.90625 17.75 10.3438C18.5 10.8125 19 11.625 19 12.5ZM12 18.9375C12 17.3125 13.2812 16 14.9062 16H18.0625C19.6875 16 21 17.3125 21 18.9375C21 19.5312 20.5 20 19.9062 20H13.0625C12.4688 20 12 19.5312 12 18.9375Z"
			fill="#6AB0BA"
		/>
	</IconBase>
);
